<template>
  <div>
    <section class="d-flex justify-content-between align-items-end">
      <div>
        <label for="search">{{ $t("generals.search") }}</label>
        <b-form-input
          id="search"
          v-model="query_params.search"
          @input="searchOffices"
        />
      </div>
      <b-button
        v-b-modal.sale-office-modal
        variant="primary"
        @click="openNewOfficeModal"
      >
        <feather-icon icon="PlusIcon" />
        {{ $t("references.add_office") }}
      </b-button>
    </section>
    <b-card class="mt-2">
      <b-table
        :fields="fields"
        :items="GET_SALE_OFFICES"
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <div class="text-center">
            {{ $t('general.no_records_to_show') }}
          </div>
        </template>
        <template #cell(image)="props">
          <div v-if="props.item.image">
            <b-img
              class="w-100"
              thumbnail
              :src="props.item.image.url"
            />
          </div>
        </template>
        <template #cell(working_hours)="props">
          {{ props.item.work_hours_start }} - {{ props.item.work_hours_end }}
        </template>
        <template #cell(actions)="props">
          <div class="d-flex justify-content-between">
            <b-button
              v-b-modal.sale-office-modal
              variant="warning"
              size="sm"
              @click="editOffice(props.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="deleteOffice(props.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
    <sale-office-modal
      :is-edit="editing"
      :def-form-obj="selected_office"
      @addSuccess="refresh"
    />
  </div>
</template>

<script>
import {
  BFormInput, BCard, BTable, BButton, BImg, VBModal,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapActions, mapGetters } from 'vuex'
import saleOfficeModal from './components/saleOfficeModal.vue'

export default {
  components: {
    BFormInput,
    BCard,
    BTable,
    BButton,
    FeatherIcon,
    BImg,
    saleOfficeModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      currentPage: 1,
      query_params: {
        search: '',
        page_size: 10,
      },
      editing: false,
      selected_office: {
        latitude: 48,
        longitude: 49,
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'width-50',
        },
        {
          key: 'image',
          label: 'references.photo',
          class: 'width-150',
        },
        {
          key: 'title',
          label: 'references.title',
        },
        {
          key: 'address',
          label: 'references.address',
        },
        {
          key: 'address',
          label: 'references.address',
        },
        {
          key: 'working_hours',
          label: 'references.work_time',
        },
        {
          key: 'actions',
          label: 'references.actions',
          class: 'width-150',
        },
      ],
      timeout: 600,
    }
  },
  computed: {
    ...mapGetters('knowledgeBase', ['GET_SALE_OFFICES']),
  },
  mounted() {
    this.FETCH_SALE_OFFICES()
  },
  methods: {
    ...mapActions('knowledgeBase', ['FETCH_SALE_OFFICES', 'DELETE_SALE_OFFICE']),
    refresh() {
      this.FETCH_SALE_OFFICES(this.query_params)
    },
    searchOffices() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.refresh()
      }, 600)
    },
    openNewOfficeModal() {
      this.editing = false
      this.selected_office = {
        latitude: 41.31115,
        longitude: 69.27970,
      }
    },
    editOffice(office) {
      this.editing = true
      this.selected_office = this.$_removeObjectConnection(office)
    },
    deleteOffice(id) {
      this.$_showAreYouSureModal().then(res => {
        if (res) {
          this.DELETE_SALE_OFFICE(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
  },
}
</script>

<style>

</style>
